import { render, staticRenderFns } from "./contectus.vue?vue&type=template&id=2806a958&scoped=true"
import script from "./contectus.vue?vue&type=script&lang=js"
export * from "./contectus.vue?vue&type=script&lang=js"
import style0 from "./contectus.vue?vue&type=style&index=0&id=2806a958&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2806a958",
  null
  
)

export default component.exports